import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/notification-bell.svg'


const _withScopeId = n => (_pushScopeId("data-v-5ebd39fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "bell-svg",
  src: _imports_0,
  alt: "notification bell"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfilePicture = _resolveComponent("ProfilePicture")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_PillButton = _resolveComponent("PillButton")!
  const _component_MomentModal = _resolveComponent("MomentModal")!
  const _component_Portal = _resolveComponent("Portal")!
  const _component_UnreadCounter = _resolveComponent("UnreadCounter")!

  return (_ctx.nameAndRoleLoaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
            'profile-wrapper',
            {
                'is-offline': !_ctx.hasNetworkConnection,
                'from-drilldown': _ctx.fromDrillDown,
            },
        ])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ProfilePicture, {
            user: _ctx.user,
            "can-edit": !_ctx.fromDrillDown
          }, null, 8, ["user", "can-edit"]),
          _createElementVNode("div", {
            class: "profile-details",
            onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onProfileTouchStart && _ctx.onProfileTouchStart(...args))),
            onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onProfileTouchEnd && _ctx.onProfileTouchEnd(...args)))
          }, [
            _createVNode(_component_Typography, {
              variant: "tabs",
              component: "span",
              class: "profile-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedUserName ? _ctx.selectedUserName : _ctx.userName), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_Typography, {
              variant: "caption",
              component: "span",
              class: "profile-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedUserType ? _ctx.selectedUserType : _ctx.userRole), 1)
              ], undefined, true),
              _: 1
            })
          ], 32),
          (_ctx.fromDrillDown)
            ? (_openBlock(), _createBlock(_component_PillButton, {
                key: 0,
                label: "New Message",
                class: "is-v4-inverted send-message-button",
                onClick: _ctx.openMessageComposer
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showPopup)
            ? (_openBlock(), _createBlock(_component_Portal, {
                key: "portal",
                to: 'over-card-destination'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MomentModal, {
                    "close-popup": () => _ctx.closeMessageComposer(),
                    "modal-source": _ctx.modalSource,
                    "selected-recipient-name": _ctx.selectedUserName
                  }, null, 8, ["close-popup", "modal-source", "selected-recipient-name"])
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
                    !_ctx.fromDrillDown && _ctx.hasNetworkConnection && _ctx.showNotifications
                )
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                id: "notification-button",
                class: _normalizeClass({
                    open: _ctx.notificationPanelOpen,
                    unread: _ctx.unseenCount > 0,
                }),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNotificationButtonClicked && _ctx.onNotificationButtonClicked(...args)))
              }, [
                _hoisted_2,
                (_ctx.unseenCount > 0)
                  ? (_openBlock(), _createBlock(_component_UnreadCounter, {
                      key: 0,
                      "unread-count": _ctx.unseenCount
                    }, null, 8, ["unread-count"]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}